import { Box, Typography } from '@mui/material';
import Markdown from 'markdown-to-jsx';
import React from 'react';
const QuestionMarkdownRenderer = ({
  content
}: {
  content: string;
}) => {
  if (!content) {
    return null;
  }
  return <Markdown options={{
    overrides: {
      p: {
        component: Typography,
        props: {
          variant: 'h6',
          paragraph: true,
          fontWeight: 700,
          fontSize: '1rem'
        }
      },
      span: {
        component: Typography,
        props: {
          variant: 'h6',
          paragraph: true,
          fontWeight: 700,
          fontSize: '1rem'
        }
      },
      ul: {
        component: Box,
        props: {
          component: 'ul',
          sx: {
            paddingLeft: '20px',
            margin: '16px 0'
          }
        }
      },
      ol: {
        component: Box,
        props: {
          component: 'ol',
          sx: {
            paddingLeft: '20px',
            margin: '16px 0'
          }
        }
      },
      li: {
        component: Box,
        props: {
          component: 'li',
          sx: {
            marginBottom: '8px',
            listStyle: 'initial'
          }
        }
      }
    }
  }} data-sentry-element="Markdown" data-sentry-component="QuestionMarkdownRenderer" data-sentry-source-file="QuestionMarkdownRenderer.tsx">
      {content}
    </Markdown>;
};
export default QuestionMarkdownRenderer;